function escapeCssSelector(value) {
	if (window.CSS && typeof window.CSS.escape === 'function') {
		return window.CSS.escape(value);
	}

	return String(value).replace(/([#.;,[\]()>+~*:=!"'\\])/g, '\\$1');
}

function getTagSelector(node) {
	const tagName = node.tagName.toLowerCase();
	const parent = node.parentElement;

	if (!parent) {
		return tagName;
	}

	const sameTagSiblings = Array.from(parent.children).filter(
		(sibling) => sibling.tagName.toLowerCase() === tagName
	);

	if (sameTagSiblings.length <= 1) {
		return tagName;
	}

	const position = sameTagSiblings.indexOf(node) + 1;
	return `${tagName}:nth-of-type(${position})`;
}

export function buildUniqueSelector(node) {
	if (!node || node.nodeType !== Node.ELEMENT_NODE) {
		return '';
	}

	const documentNode = node.ownerDocument;

	if (!documentNode) {
		return '';
	}

	const directId = node.getAttribute('id');

	if (directId) {
		const escapedId = escapeCssSelector(directId);
		const selector = `#${escapedId}`;

		if (documentNode.querySelectorAll(selector).length === 1) {
			return selector;
		}
	}

	const parts = [];
	let currentNode = node;

	while (currentNode && currentNode.nodeType === Node.ELEMENT_NODE) {
		const currentId = currentNode.getAttribute('id');

		if (currentId) {
			const escapedCurrentId = escapeCssSelector(currentId);
			parts.unshift(`#${escapedCurrentId}`);
			break;
		}

		parts.unshift(getTagSelector(currentNode));
		currentNode = currentNode.parentElement;
	}

	let selector = parts.join(' > ');

	if (selector && documentNode.querySelectorAll(selector).length === 1) {
		return selector;
	}

	if (parts.length > 1) {
		selector = `${parts[0]} ${parts.slice(1).join(' > ')}`;

		if (documentNode.querySelectorAll(selector).length === 1) {
			return selector;
		}
	}

	return parts[parts.length - 1] || '';
}
